<section class="article-list mt-4">
  <h1 class="mb-3 text-xl font-semibold text-text">Manage Numeron</h1>

  @if (isLoading()) {
    <p class="text-sm text-text-muted">Loading numeron...</p>
  } @else if (!canManage()) {
    <p class="text-sm text-text-muted">{{ loadErrorMessage() }}</p>
  } @else if (loadedCollection(); as collection) {
    @if (numeron(); as numeron) {
      <div class="container">
        <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <app-numeron-card
            [deleteReturnUrl]="returnTo()"
            [editReturnUrl]="manageReturnTo()"
            [isMyNumerons]="true"
            [numeron]="numeron"
            [numeronCollection]="collection"
            displayMode="manage"
          ></app-numeron-card>
        </div>
      </div>
    }
  }
</section>
